import Swiper, { Scrollbar } from 'swiper'
import 'swiper/css'
import 'swiper/css/scrollbar'
export class DownloadSlider {
  constructor() {
    document.addEventListener('DOMContentLoaded', function () {
      if (document.getElementById('js-download_slider') === null) return
      let slider = document.getElementById('js-download_slider')
      const downloadSlider = new Swiper('#js-download_slider', {
        modules: [Scrollbar],
        scrollbar: {
          el: '.js-download_scrollbar',
          hide: false,
          draggable: true,
        },
        slidesPerView: 2,
        spaceBetween: 20,
        breakpoints: {
          767: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          1023: {
            slidesPerView: 4,
            spaceBetween: 50,
          },
        },
      })
    })
  }
}
